import { URI_REPORT } from '@/config/config'

export default async ({ rootState }, { query }) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const client = rootState['DATA-ACCESS'].client;
  const userToken = rootState['DATA-ACCESS'].userToken;
  query.clientId = client._id;
  
  const opts = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'user-token': userToken,
    },
    body: JSON.stringify(query)
  }

  const userLoginInfoResult = await fetch(`${URI_REPORT}analytics/agent/daily`, opts)
  const jsonResult = await userLoginInfoResult.json()

  if (jsonResult.errors) {
    return Promise.reject(jsonResult.errors)
  }
  
  return jsonResult
}